const setupAccoladesLoadMore = (root) => {
  const loadMoreButton = root.querySelector('.accolades-load-more');

  if (!loadMoreButton) {
    return;
  }

  loadMoreButton.addEventListener('click', () => {
    root.querySelectorAll('.accolade.is-hidden').forEach((accolade) => {
      accolade.classList.remove('is-hidden');
    });
    loadMoreButton.remove();
  });
};

const setupAccoladesParallax = (root) => {
  const inner = root.querySelector('.inner');
  if (!inner) {
    return;
  }

  const starsTop = root.querySelector('.accolades-stars--top');
  const starsBottom = root.querySelector('.accolades-stars--bottom');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.style.setProperty('--accolades-parallax-y', '0px');
    return;
  }

  const CONTENT_MAX_SHIFT = 52;
  const STARS_MAX_SHIFT = 30;
  let rafId = null;

  const updateParallax = () => {
    rafId = null;
    const rect = root.getBoundingClientRect();
    const viewportCenter = window.innerHeight / 2;
    const sectionCenter = rect.top + rect.height / 2;
    const range = viewportCenter + rect.height / 2;
    const normalized = (viewportCenter - sectionCenter) / range;
    const clamped = Math.max(-1, Math.min(1, normalized));
    const contentShift = clamped * CONTENT_MAX_SHIFT;
    const starsShift = clamped * STARS_MAX_SHIFT;
    root.style.setProperty('--accolades-parallax-y', `${contentShift.toFixed(2)}px`);
    if (starsTop) starsTop.style.backgroundPositionY = `${starsShift.toFixed(2)}px`;
    if (starsBottom) starsBottom.style.backgroundPositionY = `calc(100% + ${starsShift.toFixed(2)}px)`;
  };

  const onScroll = () => {
    if (rafId !== null) {
      return;
    }
    rafId = window.requestAnimationFrame(updateParallax);
  };

  updateParallax();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accolades').forEach((root) => {
    setupAccoladesLoadMore(root);
    setupAccoladesParallax(root);
  });
});
